/**
 * Utility to resolve asset URLs.
 * If the URL is relative (starts with /uploads), it prepends the server URL.
 */
export const getAssetUrl = (url) => {
    if (!url || typeof url !== 'string') return "";
    
    // Normalize url
    const cleanUrl = url.trim();
    
    const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:8000/api';
    const serverUrl = baseUrl.replace('/api', '').replace(/\/$/, '');

    // Handle full URLs
    if (cleanUrl.startsWith("http")) {
        // Replace localhost with current server URL if found
        if (cleanUrl.includes("localhost")) {
            return cleanUrl.replace(/https?:\/\/localhost:\d+/, serverUrl);
        }
        return cleanUrl;
    }
    
    // Handle relative paths
    if (cleanUrl.startsWith("/uploads")) {
        return `${serverUrl}${cleanUrl}`;
    }

    if (cleanUrl.startsWith("uploads/")) {
        return `${serverUrl}/${cleanUrl}`;
    }

    // Handle S3 filenames (e.g. /file-1234.jpeg, /files-sample..., or file-1234.jpeg)
    if (cleanUrl.startsWith("/file-") || cleanUrl.startsWith("file-") || cleanUrl.startsWith("/files-") || cleanUrl.startsWith("files-")) {
        const s3Prefix = process.env.REACT_APP_S3_PREFIX || 'https://trrip-prod-storage.s3.ap-south-1.amazonaws.com';
        const filename = cleanUrl.startsWith('/') ? cleanUrl.slice(1) : cleanUrl;
        return `${s3Prefix.replace(/\/$/, '')}/${filename}`;
    }
    
    return cleanUrl;
};

export const getProxyUrl = (url) => {
    if (!url) return '';
    const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:8000/api';
    return `${baseUrl}/agent/proxy-image?url=${encodeURIComponent(url)}`;
};

